import { useSignupContext } from './useSignupContext'

export const useSignupState = () => useSignupContext().state
